/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { fileDeleteImage } from '../fn/file/file-delete-image';
import { FileDeleteImage$Params } from '../fn/file/file-delete-image';
import { fileListFolderContent$Json } from '../fn/file/file-list-folder-content-json';
import { FileListFolderContent$Json$Params } from '../fn/file/file-list-folder-content-json';
import { fileListFolderContent$Plain } from '../fn/file/file-list-folder-content-plain';
import { FileListFolderContent$Plain$Params } from '../fn/file/file-list-folder-content-plain';
import { fileRenameImage } from '../fn/file/file-rename-image';
import { FileRenameImage$Params } from '../fn/file/file-rename-image';
import { fileUpload$Json } from '../fn/file/file-upload-json';
import { FileUpload$Json$Params } from '../fn/file/file-upload-json';
import { fileUpload$Plain } from '../fn/file/file-upload-plain';
import { FileUpload$Plain$Params } from '../fn/file/file-upload-plain';

@Injectable({ providedIn: 'root' })
export class FileService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `fileUpload()` */
  static readonly FileUploadPath = '/api/File/upload';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `fileUpload$Plain()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  fileUpload$Plain$Response(params?: FileUpload$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return fileUpload$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `fileUpload$Plain$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  fileUpload$Plain(params?: FileUpload$Plain$Params, context?: HttpContext): Observable<string> {
    return this.fileUpload$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `fileUpload$Json()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  fileUpload$Json$Response(params?: FileUpload$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return fileUpload$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `fileUpload$Json$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  fileUpload$Json(params?: FileUpload$Json$Params, context?: HttpContext): Observable<string> {
    return this.fileUpload$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `fileListFolderContent()` */
  static readonly FileListFolderContentPath = '/api/File/list';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `fileListFolderContent$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  fileListFolderContent$Plain$Response(params?: FileListFolderContent$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<string>>> {
    return fileListFolderContent$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `fileListFolderContent$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  fileListFolderContent$Plain(params?: FileListFolderContent$Plain$Params, context?: HttpContext): Observable<Array<string>> {
    return this.fileListFolderContent$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<string>>): Array<string> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `fileListFolderContent$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  fileListFolderContent$Json$Response(params?: FileListFolderContent$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<string>>> {
    return fileListFolderContent$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `fileListFolderContent$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  fileListFolderContent$Json(params?: FileListFolderContent$Json$Params, context?: HttpContext): Observable<Array<string>> {
    return this.fileListFolderContent$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<string>>): Array<string> => r.body)
    );
  }

  /** Path part for operation `fileDeleteImage()` */
  static readonly FileDeleteImagePath = '/api/File/delete/{fileName}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `fileDeleteImage()` instead.
   *
   * This method doesn't expect any request body.
   */
  fileDeleteImage$Response(params: FileDeleteImage$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return fileDeleteImage(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `fileDeleteImage$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  fileDeleteImage(params: FileDeleteImage$Params, context?: HttpContext): Observable<void> {
    return this.fileDeleteImage$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `fileRenameImage()` */
  static readonly FileRenameImagePath = '/api/File/rename/{fileName}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `fileRenameImage()` instead.
   *
   * This method doesn't expect any request body.
   */
  fileRenameImage$Response(params: FileRenameImage$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return fileRenameImage(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `fileRenameImage$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  fileRenameImage(params: FileRenameImage$Params, context?: HttpContext): Observable<void> {
    return this.fileRenameImage$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
